import styled from 'styled-components';

export const ApplicationDevelopmentStatusStyled = styled.div`
	padding: 2px 8px;
	width: fit-content;
	border: 1px solid #91d5ff;
	border-radius: 24px;
	background-color: #e6f7ff;
	color: #096dd9;
	font-weight: 500;
	font-size: 12px;
`;

export const ApplicationSuccessStatusStyled = styled.div`
	padding: 2px 8px;
	width: fit-content;
	border: 1px solid #d9f7be;
	border-radius: 24px;
	background-color: #f6ffed;
	color: #52c41a;
	font-weight: 500;
	font-size: 12px;
`;

export const ApplicationWarningStatusStyled = styled.div`
	padding: 2px 8px;
	width: fit-content;
	border: 1px solid #ffe58f;
	border-radius: 24px;
	background-color: #fffbe6;
	color: #faad14;
	font-weight: 500;
	font-size: 12px;
`;
